import { Dashboard } from 'views/dashboard/dashboard';
import { Help } from 'views/dashboard/help';
import { Audience } from 'views/dashboard/audience/audience';
import { Campaign } from 'views/dashboard/campaign/campaign';
import { CampaignCreation } from 'views/dashboard/campaign/creation/create_campaign';
import { CampaignAudience } from 'views/dashboard/campaign/audienceCampaign/audience_campaign';
import { CampaignTemplates } from 'views/dashboard/campaign/themes/theme_campaign';
import { CampaignSummary } from 'views/dashboard/campaign/resume/resume';
import { CampaignFinish } from 'views/dashboard/campaign/finish/finish';
import { Automation } from 'views/dashboard/automation';
import { BackgroundCheck } from 'views/dashboard/backgroundCheck';
import { Statistics } from 'views/dashboard/statistics';
import { Leads } from 'views/dashboard/listLeads';
import { OnboardingView } from 'views/onboarding/onboarding';
import { UserValidation } from 'views/validation/validation';

const Routes = [
  {
    path: '/dashboard',
    view: Dashboard,
    layout: 'app',
    permission: 'user',
    title: 'Dashboard'
  },
  {
    path: '/welcome',
    view: OnboardingView,
    layout: 'onboarding',
    permission: 'user',
    title: 'Welcome'
  },
  {
    path: '/help',
    view: Help,
    layout: 'app',
    permission: 'user',
    title: 'Get Help'
  },
  {
    path: '/audience',
    view: Audience,
    layout: 'app',
    permission: 'user',
    title: 'Deal Finder'
  },
  {
    path: '/campaign',
    view: Campaign,
    layout: 'app',
    permission: 'user',
    title: 'Campañas'
  },
  {
    path: '/creation',
    view: CampaignCreation,
    layout: 'app',
    permission: 'user',
    title: 'Campañas'
  },
  {
    path: '/camp-audience',
    view: CampaignAudience,
    layout: 'app',
    permission: 'user',
    title: 'Campañas'
  },
  {
    path: '/theme',
    view: CampaignTemplates,
    layout: 'app',
    permission: 'user',
    title: 'Campañas'
  },
  {
    path: '/summary',
    view: CampaignSummary,
    layout: 'app',
    permission: 'user',
    title: 'Campañas'
  },
  {
    path: '/finish',
    view: CampaignFinish,
    layout: 'app',
    permission: 'user',
    title: 'Campañas'
  },
  {
    path: '/automation',
    view: Automation,
    layout: 'app',
    permission: 'user',
    title: 'Automatizaciones'
  },
  {
    path: '/background-check',
    view: BackgroundCheck,
    layout: 'app',
    permission: 'user',
    title: 'BackgroundCheck'
  },
  {
    path: '/statistics',
    view: Statistics,
    layout: 'app',
    permission: 'user',
    title: 'Estadísticas'
  },
  {
    path: '/leads',
    view: Leads,
    layout: 'app',
    permission: 'user',
    title: 'Listas de Leads'
  },
  {
    path: '/validation',
    view: UserValidation,
    layout: 'validation',
    permission: 'user',
    title: 'Validación'
  },
]

export default Routes;
